<!--订单信息-->
<template>
  <div class="orderInfo-container">
    <el-descriptions :column="1" title="订单信息" v-show="data.state==0||data.state==1||data.state==2||data.state==3||data.state==7||data.state==6 || data.state==5">
      <el-descriptions-item label="收货地址">
        <div>
          <span style="padding-right: 10px;">{{ data.consigneeUser }}</span>
          <span>{{ data.consigneePhone }}</span>
        </div>
        <div>{{ data.payAddress }}</div>
      </el-descriptions-item>
      <el-descriptions-item label="买家留言">{{ data.description || '-' }}</el-descriptions-item>
      <el-descriptions-item label="订单编号">{{ data.orderNum }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ timestampToTime(data.applictionTime) }}</el-descriptions-item>
      <el-descriptions-item label="支付时间" v-if="data.state==1||data.state==2||data.state==3||data.state==6">
        {{ timestampToTime(data.payTime) }}
      </el-descriptions-item>
      <el-descriptions-item label="支付方式" v-if="data.state==1||data.state==2||data.state==3||data.state==6">
        {{ data.payType }}
      </el-descriptions-item>
      <el-descriptions-item label="商家名称">
        <span style="padding-right: 10px;">{{ data.shopName }}</span><span>{{ data.shopPhone }}</span>
        <el-link type="primary" :underline="false" style="margin-left: 10px;" @click="ContactCustomer">联系商家</el-link>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions :column="1" title="订单信息" v-show="data.state==-2||data.state==-3||data.state==-4">
      <el-descriptions-item label="退款编号">{{ data.order_num }}</el-descriptions-item>
      <el-descriptions-item label="退款金额">￥{{ data.returnMoney }}</el-descriptions-item>
      <el-descriptions-item label="退款原因">{{ data.reason }}</el-descriptions-item>
      <el-descriptions-item label="申请时间">{{ timestampToTime(data.applictionT) }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  name: "orderInfo",
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    state: {
      type: Number,
      default() {
        return 0
      }
    },
  },
  methods: {
    // 时间格式
    timestampToTime(timestamp) {
      if (timestamp != '' && timestamp != undefined && timestamp != 0 && timestamp != null) {
        let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + "-";
        let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
        let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
        let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      }else
        return '';
    },
    /*联系客服*/
    ContactCustomer(){
      console.log(this.data);
      let routeData = this.$router.resolve({
        name: "onlineService",
        path: '/onlineService/index',
        query:{
          id:this.data.shopId
        }
      });
      window.open(routeData.href, '_blank')
    }
  },
}
</script>
<style scoped>
.orderInfo-container >>> .el-descriptions__header {
  margin-bottom: 0px;
  background: #F1F1F1;
  border: 1px solid #dddddd;
  padding: 15px 20px;
}

.orderInfo-container >>> .el-descriptions__title {
  font-size: 16px;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
  color: #333333;
}

.orderInfo-container >>> .el-descriptions-item__container .el-descriptions-item__content, .el-descriptions-item__container .el-descriptions-item__label {
  display: block;
}

.orderInfo-container >>> .el-descriptions__body {
  color: #333333;
  background-color: #F9F9F9;
  border: 1px solid #DDDDDD;
  padding: 20px;
  border-top: none;
}

.orderInfo-container >>> .el-link {
  vertical-align: initial;
  font-size: 14px;
}

.orderInfo-container >>> .el-link.el-link--primary {
  color: #0067DD;
}
</style>
<style scoped lang="scss">
.orderInfo-container {
  p {
    margin-block-start: 0px;
    margin-block-end: 0px;
  }
}
</style>